import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00af4a",
      contrastText: "#fff",
      copy: "#58595b",
      blue: "rgba(28,172,232,.2)",
      graph: "rgba(0,175,74,.6)",
      greenHighlight: "#14C35E",
    },
    secondary: {
      main: "#ed7044",
    },
    background: {
      main: "#E7E7E7",
    },
    error: {
      main: "#ed7044",
    },
    NAS: {
      green: "#00af4a",
      lightGreen: "#78c040",
      blue: "#445bab",
      lightBlue: "#1cace8",
      magenta: "#a652a0",
      orange: "#ed7044",

      greenHighlight: "#14C35E",
      lightGreenHighlight: "#8CD454",
      blueHighlight: "#586FBF",
      lightBlueHighlight: "#30C0FC",
      magentaHighlight: "#BA66B4",
      orangeHighlight: "#FF8462",
    },
  },
});

const adminTheme = createTheme({
  palette: {
    primary: {
      main: "#445bab",
    },
  },
});

export default theme;
export { adminTheme };
